import { serviceURL } from "../../../../../utils/service-url";

import type { UUID } from "../../../../../utils/uuid";

export function makeSurveyUrl(
  acc_id: string,
  surveyId: string,
  config: { anonymous: boolean },
): string {
  const tags = config.anonymous
    ? {}
    : {
        person_id: "{{person_id}}",
        moment_id: "{{moment_id}}",
        outbox_id: "{{outbox_id}}",
        on_behalf_of_person_id: "{{on_behalf_of_person_id}}",
      };

  const data = {
    account_id: acc_id,
    survey_id: surveyId,
    anonymous: config.anonymous,
    preview: false,
    ...tags,
  };

  const jwtBlock = `{{#jwt}}${JSON.stringify(data)}{{/jwt}}`;
  return `${serviceURL("poll-position")}survey/jwt/${jwtBlock}`;
}

export function extractSurveyUrl(text: string): string | null {
  const surveyRegex =
    /(https?:\/\/[^\s]+\/survey\/[^\s"]+?(?:\/jwt\/[^\s"]+|{{#jwt}}[^\s]+{{\/jwt}}))/;
  const match = surveyRegex.exec(text);
  return match ? match[0] : null;
}

export function getSurveyIdFromUrl(url?: string): UUID | null {
  if (!url) return null;

  const parsedUrl = decodeURIComponent(url);

  if (parsedUrl.includes("{{#jwt}}")) {
    const jwtMatch = /survey\/jwt\/\{\{#jwt\}\}([^/]+)\{\{\/jwt\}\}/.exec(parsedUrl);
    const rawPayload = jwtMatch?.[1];
    const decodedPayload = rawPayload?.replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    const jwtData = decodedPayload ? (JSON.parse(decodedPayload) as { survey_id: UUID }) : null;
    return jwtData?.survey_id ?? null;
  }

  const regex =
    /\/survey\/[^/]+\/([^/]+)\/\{\{person_id\}\}\?moment_id=\{\{moment_id\}\}&outbox_id=\{\{outbox_id\}\}/;
  const match = regex.exec(parsedUrl);
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  return match ? (match[1] as UUID) : null;
}
